import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { keyBy } from "lodash";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { getDaysInMonth, getMonth, getYear } from "date-fns";
import { makeStyles } from "@material-ui/core";


import { formatAsDay } from "../../../../utils/shookit"
import { CircularProgress } from "@material-ui/core";
import * as locationApi from "../../../../services/locationApi";
import { STORE_ID } from "../../../../config";

const useStyles = makeStyles(theme => ({
  buttonPadding: {
    padding: "5px 16px",
    "&:hover": { padding: "5px 16px" }
  }
}));

export default function EditDeliveryDialog({
  onClose,
  open,
  role,
  currentSite,
  currentDay,
  currentStart,
  currentEnd,
  city
}) {
  const classes = useStyles();
  // const history = useHistory();

  const maxDatesToShow = 7;
  const [availableTimeslots, setAvailableTimeslots] = useState([]);
  const [selectedWindow, setSelectedWindow] = useState(null);
  const [selectedTs, setSelectedTs] = useState(null);

  const [isLoading, setIsLoading] = useState(true);
  const [geoError, setGeoError] = useState(null);

  const getAvailableTimeslots = async () => {
    const response = await locationApi.fetchAvailableTimeSlots(STORE_ID, city);
    if (response.status === 200) {
      setAvailableTimeslots(response.data);
    } else {
      setGeoError({ message: "Failed to load site information" });
    }
  }

  useEffect(() => {
    if (!city)
      return;

    getAvailableTimeslots()
      .then(() => {
        setIsLoading(false);
      })
      .catch(err => {
        console.error(err);
      });
  }, [city]);

  useEffect(()=>{
    if(availableTimeslots)
      findSelectedTimeslots(availableTimeslots);

  }, [availableTimeslots])

  const onCancelClicked = e => {
    if (onClose) {
      onClose(null);
    }
  };

  const selectWindowSlot = timeslot => {
    setSelectedWindow(timeslot);
    setSelectedTs(null);
  };

  const isSameDate = (date1, date2) => {
    if (!date1 || !date2)
      return;

    const _date1 = new Date(date1);
    const _date2 = new Date(date2);

    return _date1.getFullYear() === _date2.getFullYear() &&
           _date1.getMonth() === _date2.getMonth() &&
           _date1.getDate() === _date2.getDate();
  }

  function findSelectedTimeslots(timeslots) {
    if (currentDay === null) {
      return;
    }

    const day = new Date(currentDay);

    timeslots.forEach((window, index) => {
      if (isSameDate(window.date, day)) {
        setSelectedWindow(window);

        // Find timeslot
        const currentTs =  window.timeSlots.find(ts=> ts.time ===`${currentStart}-${currentEnd}`)
        if(currentTs)
          setSelectedTs(currentTs);
      }
    });
  }

  async function onSaveClicked() {
    if(!selectedTs)
      return;

    let leaveAtDoor = selectedTs?.window === 'evening' ? 1 : 0;
    const [selectedTsStart, selectedTsEnd] = selectedTs.time.split('-').map(ts=> ts?.trim ? ts.trim() : ts);

    onClose({
      day: new Date(selectedWindow.date).toISOString(),
      start: selectedTsStart,
      end: selectedTsEnd,
      leaveAtDoor
    });
  }

  const selectTs = ts => {
    setSelectedTs(ts);
  };

  if (isLoading) {
    return (
      <Dialog open={open} onClose={onCancelClicked} maxWidth="lg">
        <DialogTitle>Update delivery</DialogTitle>
        <DialogContent>
          <CircularProgress/>
        </DialogContent>
      </Dialog>
    );
  }

  if (geoError) {
    return (
      <Dialog open={open} onClose={onCancelClicked} maxWidth="lg">
        <DialogTitle>Can not create new</DialogTitle>
        <DialogContent dividers>
          <Typography>
            Due to an errror: <i>{geoError.message}</i>
          </Typography>
        </DialogContent>
      </Dialog>
    );
  }

  function renderTimeSlots() {
    const selectedTimeSlot = availableTimeslots
      .find(ts => isSameDate(selectedWindow.date, ts.date));

    if (!selectedTimeSlot?.timeSlots) return;

    return selectedTimeSlot.timeSlots.map(slot =>
      <Grid item key={slot.time}>
        <Button
          className={classes.buttonPadding}
          variant={selectedTs?.time === slot.time && selectedTs?.window === slot.window  ? "outlined" : "text"}
          color={selectedTs?.time === slot.time && selectedTs?.window === slot.window  ? "primary" : "default"}
          onClick={() => selectTs(slot)}>
          {slot.time}
        </Button>
      </Grid>
    )
  }

  return (
    <Dialog open={open} onClose={onCancelClicked} maxWidth="lg">
      <DialogTitle>Update delivery</DialogTitle>
      <DialogContent dividers>
        <Typography varian="h4">Select Day</Typography>
        <Grid container direction="row">
          {availableTimeslots?.slice(0, maxDatesToShow).map(ts => (
            <Grid item key={ts.date}>
              <Button
                variant={ isSameDate(selectedWindow?.date, ts.date) ? "outlined" : "text"}
                className={classes.buttonPadding}
                color={isSameDate(selectedWindow?.date, ts.date) ? "primary" : "default"}
                onClick={() => selectWindowSlot(ts)}>
                {formatAsDay(new Date(ts.date))}
              </Button>
            </Grid>
          ))}
        </Grid>
        <br/>
        <Typography varian="h4">Select Time slot</Typography>
        <Grid container direction="column">
          {selectedWindow != null && renderTimeSlots()}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onCancelClicked}>
          Cancel
        </Button>
        <Button
          color="primary"
          type="submit"
          disabled={!selectedTs}
          onClick={onSaveClicked}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
